import axios from 'axios';

export const generateAxiosInstanceCommonFileUpload = () => {
  const baseURL = process.env.REACT_APP_BACKEND_COMMON_URL; // Your base URL
  const accessToken = localStorage.getItem('accessToken');
  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const generateAxiosInstanceAdminFileUpload = () => {
    const baseURL = process.env.REACT_APP_BACKEND_ADMIN_URL; // Your base URL
    const accessToken = localStorage.getItem('accessToken');
    return axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
};

export const generateAxiosInstanceInstituteFileUpload = () => {
    const baseURL = process.env.REACT_APP_BACKEND_INSTITUTE_URL; // Your base URL
    const accessToken = localStorage.getItem('accessToken');
    return axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
};

export const generateAxiosInstanceSectionFileUpload = () => {
    const baseURL = process.env.REACT_APP_BACKEND_SECTION_URL; // Your base URL
    const accessToken = localStorage.getItem('accessToken');
    return axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
};

// Use this function whenever you need axiosInstance
// const axiosInstance = generateAxiosInstance();
// export default axiosInstance;
